export default "__VITE_ASSET__2E6QsCQW__"